import * as React from 'react';
import {type Category, type CategoryMapping} from '@/types';
import { Table, TableHeader, TableBody, TableHead, TableRow, TableCell } from '../ui/table';
import { RiDeleteBinLine, RiEditLine } from 'react-icons/ri';
import { Button } from '../atoms/button';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useNavigate, useParams } from '@tanstack/react-router';

export interface CategoryMappingsListProps {
    categoryMappings: CategoryMapping[]| null;
}

export function CategoryMappingsList(props: CategoryMappingsListProps) {
    const navigate = useNavigate();
    const params = useParams({ from: '/categories/mappings/$subcategoryId' });
    const queryClient = useQueryClient();
    if (!props.categoryMappings) {
        return null;
    }

    const categoryMappings = props.categoryMappings || [];

    return (<div className="categories-list">
        <Table>
            <TableHeader>
                <TableRow>
                    <TableHead>Store</TableHead>
                    <TableHead>Mapping</TableHead>
                    <TableHead>Actions</TableHead>
                </TableRow>
            </TableHeader>
            <TableBody>
                {categoryMappings.map((categoryMapping: CategoryMapping) => (
                    <TableRow key={categoryMapping.uid}>
                        <TableCell>{categoryMapping.storeId}</TableCell>
                        <TableCell>{categoryMapping.storeCategoryId}</TableCell>
                        <TableCell>
                            <Button onClick={() => {}}>Delete</Button>
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    </div>)
}
